/** @file Viewport ShownAttachment: what each slot shows in the posed scene (skins, attachment keys). */
import type { Pose, SkeletonData } from '@pose2d/core/types';
import type { Doc, Id } from '@pose2d/format/types';
import type { ShownAttachment } from './meshTarget';

/** Maps doc slot id → compiled slot (by name) → pose.slotAttachment → doc attachment id (by name; names are unique). */
export function poseShownAttachment(doc: Doc, data: SkeletonData, pose: Pose): ShownAttachment {
  const byName = new Map<string, Id>(Object.entries(doc.attachments).map(([id, a]) => [a.name, id]));
  return (slot) => {
    const name = doc.slots[slot]?.name;
    const index = name === undefined ? undefined : data.slotIndex.get(name);
    const att = data.attachments[index === undefined ? -1 : (pose.slotAttachment[index] ?? -1)];
    return att === undefined ? null : (byName.get(att.name) ?? null);
  };
}
